import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './CarSourcingForm.css'; // Import the CSS file

const CarSourcingForm = () => {
  const location = useLocation();
  const { name, email, phone } = location.state || {}; // Get user details passed from the previous page

  const [formData, setFormData] = useState({
    make: '',
    model: '',
    year: '',
    fuelType: '',
    transmission: '',
    price: '',
    applicantName: name || '', // Set the user details from state
    applicantEmail: email || '',
    applicantPhone: phone || ''
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Store form data in local storage before redirecting to payment page
    localStorage.setItem('sourcingData', JSON.stringify(formData));

    // Redirect to the payment page
    navigate('/payment');
  };

  return (
    <div className="sourcing-form-container">
      <h2>Car Sourcing Information</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Make:</label>
          <input type="text" name="make" value={formData.make} onChange={handleChange} required />
        </div>
        <div>
          <label>Model:</label>
          <input type="text" name="model" value={formData.model} onChange={handleChange} required />
        </div>
        <div>
          <label>Year:</label>
          <input type="text" name="year" value={formData.year} onChange={handleChange} required />
        </div>
        <div>
          <label>Fuel Type:</label>
          <input type="text" name="fuelType" value={formData.fuelType} onChange={handleChange} required />
        </div>
        <div>
          <label>Transmission:</label>
          <input type="text" name="transmission" value={formData.transmission} onChange={handleChange} required />
        </div>
        <div>
          <label>Budget:</label>
          <input type="number" name="price" value={formData.price} onChange={handleChange} required />
        </div>
        {/* Display applicant's information */}
        <div>
          <label>Applicant Name:</label>
          <input type="text" name="applicantName" value={formData.applicantName} readOnly />
        </div>
        <div>
          <label>Applicant Email:</label>
          <input type="email" name="applicantEmail" value={formData.applicantEmail} readOnly />
        </div>
        <div>
          <label>Applicant Phone:</label>
          <input type="tel" name="applicantPhone" value={formData.applicantPhone} readOnly />
        </div>
        <button type="submit">Proceed to Payment</button>
      </form>
    </div>
  );
};

export default CarSourcingForm;
